import Action from '../base/action';

class SceneTransformation extends Action {
    position;
    quaternion;
    scale;

    constructor(props) {
        super(props);
        this.position = props.position ? props.position : [0, 1.6, 0];
        this.quaternion = props.quaternion ? props.quaternion : [0, 0, 0, 1];
        this.scale = props.scale ? props.scale : [1, 1, 1];
    }

    async execute() {
        const position = new THREE.Vector3().fromArray(this.position);
        const quaternion = new THREE.Quaternion().fromArray(this.quaternion);
        const scale = new THREE.Vector3().fromArray(this.scale);
        wv.rootObject.position.copy(position);
        wv.rootObject.quaternion.copy(quaternion);
        wv.rootObject.scale.copy(scale);
        wv.rootObject.updateMatrix();
        wv.rootObject.updateMatrixWorld(true);
    }
}

export default SceneTransformation;
